import React from 'react'

import Input from '../ui/input'
import FieldLabel from '../ui/input/FieldLabel'
import { DraftClient } from '../../lib/guestInvoiceDraftStorage'

type Props = {
  draftClient: DraftClient
  onChange: (draftClient: DraftClient) => void
  showErrors?: boolean
  flashNonce?: number
}

const GuestDraftClientFields: React.FC<Props> = ({
  draftClient,
  onChange,
  showErrors = false,
  flashNonce = 0,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = event.target
    onChange({ ...draftClient, [name]: value })
  }

  const missingTradingName = !draftClient.tradingName?.trim()

  return (
    <div
      key={flashNonce}
      data-invoice-field='client'
      className={`invoice-prereq-box position-relative ${showErrors ? ' invoice-prereq-box--error invoice-prereq-box--flash' : ''}`}
    >
      <div className='mb-3'>
        <FieldLabel label='Trading Name' htmlFor='draftClient.tradingName' required />
        <input
          className={`form-control form-control-md${showErrors && missingTradingName ? ' is-invalid' : ''}`}
          id='draftClient.tradingName'
          name='tradingName'
          placeholder='Your client trading name'
          value={draftClient.tradingName}
          onChange={handleChange}
          required
        />
      </div>
      <div className='mb-3'>
        <Input
          label='Email'
          id='draftClient.email'
          name='email'
          type='email'
          placeholder='Your client email'
          value={draftClient.email}
          onChange={handleChange}
          optional
        />
      </div>
      <div className='mb-0'>
        <Input
          label='Billing Address'
          id='draftClient.billingAddress'
          name='billingAddress'
          placeholder='Your client billing address'
          value={draftClient.billingAddress}
          onChange={handleChange}
          optional
        />
      </div>
      {showErrors && missingTradingName && (
        <small className='text-danger position-absolute start-50 translate-middle-x bottom-0'>
          Required
        </small>
      )}
    </div>
  )
}

export default GuestDraftClientFields
